import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, DEFAULT_LANG } from '../i18n';

/**
 * Returns the URL prefix for the current language.
 * The default language (FR) has no prefix → "".
 * Non-default languages get a prefix like "/en".
 *
 * Usage:
 *   const prefix = useLangPrefix();
 *   <Link to={`${prefix}/contact`}>Contact</Link>
 */
export function useLangPrefix() {
  const { i18n } = useTranslation();
  const lang = SUPPORTED_LANGS.find((l) => l.code === i18n.language);
  // Default language has no URL prefix
  if (!lang || lang.isDefault) return '';
  return `/${lang.code}`;
}

// Keep old name as alias for backward compatibility
export const useLangPrefix_legacy = useLangPrefix;

/**
 * Build a localized path.
 * localePath('/contact') → '/contact' (FR) or '/en/contact' (EN)
 */
export function useLocalePath() {
  const prefix = useLangPrefix();
  return (path) => `${prefix}${path}`;
}
